import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const SearchButton = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      sx={{
        padding: "8px 16px 8px 12px",
        height: "42px",
        display: "inline-flex",
        flexShrink: 0,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: "8px",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "normal",
        borderRadius: "6px",
        backgroundColor: "var(--main-color)",
        color: "#FFFF",
        border: "none",
        textTransform: "none",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: "0 2px 4px #91A3FF",
        },
      }}
    >
      {t("privateArea.mydatasets.search")}
    </Button>
  );
};

export default SearchButton;
